module.exports = __webpack_public_path__ + "img/parametres.4008c5ac.png";